(() => {
  'use strict';

  const announce = (message) => {
    const region = document.getElementById('SelntzLiveRegion');
    if (!region) return;
    region.textContent = '';
    window.setTimeout(() => { region.textContent = message; }, 50);
  };

  const formatMoney = (cents, format = window.Selntz?.moneyFormat || '${{amount}}') => {
    const value = Number(cents || 0);
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const withDelimiter = (number, precision = 2, thousands = ',', decimal = '.') => {
      if (!Number.isFinite(number)) return '0';
      const parts = (number / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? `${parts[0]}${decimal}${parts[1]}` : parts[0];
    };
    const token = format.match(placeholder)?.[1] || 'amount';
    let formatted;
    switch (token) {
      case 'amount_no_decimals': formatted = withDelimiter(value, 0); break;
      case 'amount_with_comma_separator': formatted = withDelimiter(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': formatted = withDelimiter(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': formatted = withDelimiter(value, 2, "'", '.'); break;
      default: formatted = withDelimiter(value, 2); break;
    }
    return format.replace(placeholder, formatted);
  };

  window.Selntz = Object.assign(window.Selntz || {}, { announce, formatMoney });

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let revealObserver = null;

  const getRevealObserver = () => {
    if (revealObserver || !('IntersectionObserver' in window)) return revealObserver;
    revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    return revealObserver;
  };

  const initReveals = (scope = document) => {
    const elements = [];
    if (scope instanceof Element && scope.matches('[data-reveal]:not([data-reveal-ready]):not([data-theme-reveal-ready])')) {
      elements.push(scope);
    }
    scope.querySelectorAll?.('[data-reveal]:not([data-reveal-ready]):not([data-theme-reveal-ready])').forEach((item) => elements.push(item));

    elements.forEach((item) => {
      item.setAttribute('data-theme-reveal-ready', 'true');
      if (reducedMotion.matches || !('IntersectionObserver' in window)) {
        item.classList.add('is-revealed');
      } else {
        getRevealObserver().observe(item);
      }
    });
  };

  initReveals(document);

  let headerToneFrame = 0;

  const updateHeaderTone = () => {
    headerToneFrame = 0;

    const root = document.documentElement;
    const header = document.querySelector('[data-site-header]');
    const darkSections = document.querySelectorAll('[data-header-tone="dark"]');

    if (!header || darkSections.length === 0) {
      root.classList.remove('header-over-dark');
      return;
    }

    const headerRect = header.getBoundingClientRect();
    let chromeBottom = Math.max(0, headerRect.bottom);

    document.querySelectorAll('.product-navigation-section').forEach((navigation) => {
      const navigationRect = navigation.getBoundingClientRect();
      const sitsBelowHeader = navigationRect.top <= headerRect.bottom + 2;
      const remainsVisible = navigationRect.bottom > headerRect.bottom;

      if (sitsBelowHeader && remainsVisible) {
        chromeBottom = Math.max(chromeBottom, navigationRect.bottom);
      }
    });

    const probeY = Math.min(window.innerHeight - 1, chromeBottom + 1);
    const isOverDark = Array.from(darkSections).some((section) => {
      const sectionRect = section.getBoundingClientRect();
      return sectionRect.top <= probeY && sectionRect.bottom > probeY;
    });

    root.classList.toggle('header-over-dark', isOverDark);
  };

  const scheduleHeaderTone = () => {
    if (headerToneFrame) return;
    headerToneFrame = window.requestAnimationFrame(updateHeaderTone);
  };

  scheduleHeaderTone();
  window.addEventListener('scroll', scheduleHeaderTone, { passive: true });
  window.addEventListener('resize', scheduleHeaderTone, { passive: true });
  window.addEventListener('pageshow', scheduleHeaderTone);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quantity-action]');
    if (!trigger) return;
    const wrapper = trigger.closest('[data-quantity]');
    const input = wrapper?.querySelector('input[type="number"]');
    if (!input) return;
    const step = Number(input.step) || 1;
    const minimum = Number(input.min) || 1;
    const maximum = input.max ? Number(input.max) : Infinity;
    const direction = trigger.dataset.quantityAction === 'increase' ? 1 : -1;
    input.value = Math.max(minimum, Math.min(maximum, Number(input.value || minimum) + (step * direction)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('shopify:section:load', (event) => {
    initReveals(event.target);
    scheduleHeaderTone();
  });
})();
